import { GraphsGeneral } from "../types/campaigns";
import { ENV } from "../utils/constants";
import api from "./api";

export const getMetricsGeneral = async (): Promise<any> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/general`,
    {}
  );
  return data?.content;
};

export const getGraphsGeralLikesData = async (): Promise<GraphsGeneral[]> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfacegraphicoverview-likes`,
    {}
  );
  return data?.content;
};

export const getGraphsGeralViewsData = async (): Promise<GraphsGeneral[]> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfacegraphicoverview-views`,
    {}
  );
  return data?.content;
};

export const getGraphsGeralEngajamentsData = async (): Promise<
  GraphsGeneral[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfacegraphicoverview-engagaments`,
    {}
  );
  return data?.content;
};

export const getGraphsGeralImpressionsData = async (): Promise<
  GraphsGeneral[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfacegraphicoverview-impressions`,
    {}
  );
  return data?.content;
};

export const getGraphsGeralCommentsData = async (): Promise<
  GraphsGeneral[]
> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfacegraphicoverview-comments`,
    {}
  );
  return data?.content;
};

// Counter
export const getGeralLikesCounterData = async (): Promise<number> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfaceoverview-likes`,
    {}
  );
  return data?.content[0].total;
};

export const getGeralViewsCounterData = async (): Promise<number> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfaceoverview-views`,
    {}
  );
  return data?.content[0].total;
};

export const getGeralEngajamentsCounterData = async (): Promise<number> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfaceoverview-engagaments`,
    {}
  );
  return data?.content[0].total;
};

export const getGeralImpressionsCounterData = async (): Promise<number> => {
  const { data } = await api.get(
    `/advertising-dashboard-${ENV}/metrics/count/instfaceoverview-impressions`,
    {}
  );
  return data?.content[0].total;
};

export const getUpdatedCampaignsFaceInsta = async () => {
  try {
    const { data } = await api.get(
      `/social-networks-v2-${ENV}/insights/updatedCampaignsFaceInsta`,
      {}
    );
    return data?.content;
  } catch (err) {
    return err;
  }
}